<nz-card>
    <div class="bundle-container">
        <div class="bundle-image__container">
            <img [src]="bundle.render?.thumbnailUrl" alt="Bundle Image">
        </div>

        <div class="bundle-info__container">
            <div class="bundle-info__name">{{ bundle.name }}</div>
            <div class="bundle-info__description" [innerHTML]="bundle.description | htmlBypass | ellipsis:['180']">
            </div>
            <div class="bundle-info__suffix">
                <span class="label">Products:</span>
                <span class="value">{{ bundle.productsCount }}</span>

                <ng-container *ngIf="selectedLicenseType">
                    <span class="label">Licenses:</span>
                    <nz-select
                            class="select-value"
                            [nzCustomTemplate]="customTemplate"
                            nzSize="small"
                            [ngModel]="selectedLicenseType"
                            (ngModelChange)="licenseChanged($event)"
                    >
                        <nz-option *ngFor="let item of licenseNameList" [nzValue]="item" [nzLabel]="item"></nz-option>
                    </nz-select>
                    <nz-select
                            *ngIf="selectedLicenseTerms.repeatDurationType || selectedLicenseTerms.durationType"
                            class="select-value"
                            nzSize="small"
                            [ngModel]="selectedLicenseTerms"
                            (ngModelChange)="termChanged($event)"
                    >
                        <nz-option
                                *ngFor="let item of termsList"
                                [nzValue]="item"
                                [nzLabel]="item.repeatDurationType || (item.duration ? item.duration + ' ': '') + item.durationType"
                        ></nz-option>
                    </nz-select>
                </ng-container>
            </div>
        </div>

        <div class="bundle-suffix__container">
            <span class="bundle-suffix__price" *ngIf="selectedLicenseType">{{ price }}</span>
            <a class="bundle-suffix__link" [routerLink]="['/products/details', bundle.proxyProductMasterSku]" [queryParams]="{ license: selectedLicenseSku }">View all</a>
        </div>
    </div>
</nz-card>

<ng-template #customTemplate let-selected>
    <b>{{ selected.nzValue }}</b>
</ng-template>
